import React, { Fragment } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
    Modal, Box, Typography,
    Paper, Divider, IconButton, Button, Tooltip
} from '@mui/material';

import Icon from '@mdi/react';
import {
    mdiCloseCircleOutline,
    mdiFileDocumentOutline,
    mdiDownload,
    mdiCog,
    mdiReplay,
    mdiLockReset
} from '@mdi/js';

import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { selectedTripSelector } from '../../../features/tripcenter/tripControlSlice';
import { userSelector } from '../../../features/user/UserSlice';


const TripDataViewModal = ({ dataViewOpen, handleDataViewClose, handleCancelClick, handleReprocess, handleShowLog, handleDownloadLog, handleSettingsOpen, handleResetTrip, handleForceComplete }) => {

    const dimention = useSelector(liveTrackinglayoutSelector);
    const trip = useSelector(selectedTripSelector);
    const user = useSelector(userSelector);
    const { isAdmin } = user;

    if (!dataViewOpen) return null;
    if (!trip) return null;
    console.log("Trip", trip.truckRegistrationNumber, trip.lastCheckTime, trip.lastCheckResult);
    const formatDateTime = (dateString) => {
        const gmtDate = moment.utc(dateString);
        const istDate = gmtDate.clone().add(5, 'hours').add(30, 'minutes');
        return istDate.format("DMMM YYYY, hh:mm A");
    };

    const shortDate = (dateString) => {
        const gmtDate = moment.utc(dateString);
        const istDate = gmtDate.clone().add(5, 'hours').add(30, 'minutes');
        return istDate.format("DMMM, h:mm a");
    };


    const formatLocationType = (locationType) => {
        if (!locationType) return '';

        const str = locationType
            .replace('Location', '')
            .replace('via', 'Stoppage')
            .charAt(0)
            .toUpperCase() +
            locationType
                .replace('Location', '')
                .replace('via', 'Stoppage')
                .slice(1)
                .toLowerCase();
        return str;
    };

    const formatViolations = (violations) => {
        if (!violations || violations.length === 0) return { overallCount: 0, typeCount: {} };
        const overallCount = violations.filter(violation => violation.eventType === 'ruleViolation').length;
        let typeCount = {};
        violations.forEach(violation => {
            if (violation.eventType === 'ruleViolation') {
                typeCount[violation.eventName] = (typeCount[violation.eventName] || 0) + 1;
            }
        });
        return { overallCount, typeCount };
    };


    return (
        <Modal
            open={dataViewOpen} //todo
            onClose={handleDataViewClose}
        >
            <Paper style={{ ...dimention.assetEventList, bgcolor: 'white', maxHeight: '90vh', minWidth: '30vw' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'MidnightBlue', p: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'white', ml: 1 }}>
                        Trip Details
                    </Typography>
                    <IconButton onClick={handleDataViewClose}>
                        <Icon path={mdiCloseCircleOutline} size={1} color="white" />
                    </IconButton>
                </Box>
                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: 2
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Truck
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip.truckRegistrationNumber} {isAdmin && trip.deviceImei} {isAdmin && trip._id}
                            </Typography>
                            {isAdmin && (
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Check: {moment.parseZone(trip.lastCheckTime).format('DD-MM HH:mm')} | {trip.lastCheckResult} | Slow: {trip.lastPathMetricsCheck && moment(trip.lastPathMetricsCheck).format('HH:mm')}
                                </Typography>
                            )}
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Driver
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip.driverName}
                            </Typography>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Phone
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip.driverPhoneNumber}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: 2
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Fuel in Tank
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip?.fuelInTank || 0} L
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Consumption
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {(trip?.fuelConsumption)?.toFixed(1)} L
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Mileage
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {(trip?.fuelEfficiency)?.toFixed(1)} km/L
                            </Typography>
                        </Box>
                    </Box>
                    <Divider />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: 2
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Truck Run
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip?.truckRunDistance?.toFixed(0)} Km
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Average Speed
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip?.averageSpeed?.toFixed(0)} km/h
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Top Speed
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip?.topSpeed?.toFixed(0)} km/h
                            </Typography>
                        </Box>
                    </Box>
                    <Divider />
                    {trip.currentSignificantLocation && (
                        <Fragment>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                gap: 2
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    gap: 1
                                }}>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                        Currently at
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                        {trip?.currentSignificantLocation?.locationName || 'N/A'}
                                        {trip?.currentSignificantLocation?.locationType ?
                                            `(${formatLocationType(trip.currentSignificantLocation.locationType)})` :
                                            ''
                                        }
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 2,
                                    gap: 1
                                }}>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                        Reached
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                        {formatDateTime(trip?.currentSignificantLocation?.entryTime)} | {moment.utc(trip?.currentSignificantLocation?.entryTime).fromNow()}
                                    </Typography>
                                </Box>
                            </Box>
                            <Divider />
                        </Fragment>
                    )}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: 2
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 2,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Route
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip?.route?.routeName?.split('|')[0]}
                            </Typography>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Distance
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {(trip?.route?.routeLength)?.toFixed(0)} km
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: 2
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 2,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Customer
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip?.customer}
                            </Typography>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Goods
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip?.goodsName}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: 2
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Activity
                            </Typography>
                            <Typography variant="body1" sx={{ color: trip?.activeStatusColor }}>
                                {trip?.activeStatus}
                            </Typography>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Status
                            </Typography>
                            <Typography variant="body1" sx={{ color: trip?.stageColor }}>
                                {trip?.tripStage}
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                {trip?.actualStartTime ? 'Started' : 'Planned'}
                            </Typography>
                            {
                                trip?.actualStartTime &&
                                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                                    {formatDateTime(trip?.actualStartTime)}
                                </Typography>
                            }
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Plan: {shortDate(trip?.plannedStartTime)}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: 2
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Completed
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {trip?.completionPercentage?.toFixed(0)} %
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Covered
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {(trip?.distanceCovered)?.toFixed(1)} km
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1
                        }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'Navy' }}>
                                Remaining
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {(trip?.distanceRemaining)?.toFixed(1)} km
                            </Typography>
                        </Box>
                    </Box>
                    <Divider />
                    {formatViolations(trip?.significantEvents).overallCount > 0 && (
                        <Fragment>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                gap: 2
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    gap: 1
                                }}>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: 'Crimson' }}>
                                        Violations
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                        {formatViolations(trip?.significantEvents).overallCount}
                                    </Typography>
                                </Box>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 2,
                                    gap: 1
                                }}>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: 'Crimson' }}>
                                        Violation Types
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                        {Object.entries(formatViolations(trip?.significantEvents).typeCount).map(([type, count]) => `${type}: ${count}`).join(' | ')}
                                    </Typography>
                                </Box>
                            </Box>
                            <Divider />
                        </Fragment>
                    )}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        gap: 2,
                        border: '1px solid darkgray',
                        borderRadius: '5px',
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: 1,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Button
                                fullWidth
                                size="small"
                                variant="text"
                                color="error"
                                onClick={() => handleCancelClick(trip)}
                            >
                                {trip?.tripStage === 'Active' ? 'Abort Trip' : 'Cancel Trip'}
                            </Button>
                        </Box>
                        {trip?.tripStage === 'Active' && (
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: 1,
                                gap: 1,
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <Button
                                    fullWidth
                                    size="small"
                                    variant="text"
                                    color="warning"
                                    onClick={handleForceComplete}
                                >
                                    Force Complete
                                </Button>
                            </Box>
                        )}
                        {isAdmin ?
                            (
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    gap: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'center', alignItems: 'center' }}>
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={() => handleShowLog(trip.tripId)}
                                        >
                                            <Icon path={mdiFileDocumentOutline} size={0.75} />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={() => handleDownloadLog(trip.tripId)}
                                        >
                                            <Icon path={mdiDownload} size={0.75} />
                                        </IconButton>
                                        {/* <IconButton
                                            size="small"
                                            onClick={() => handleReprocess()}
                                            color="primary"
                                            disabled={trip.tripStage === 'Completed'}
                                        >
                                            <Tooltip title="Reprocess Trip">
                                                <Icon path={mdiReplay} size={0.75} />
                                            </Tooltip>
                                        </IconButton> */}
                                        <IconButton
                                            size="small"
                                            onClick={() => handleResetTrip()}
                                            color="error"
                                        //disabled={trip.tripStage === 'Completed'}
                                        >
                                            <Tooltip title="Reset Trip">
                                                <Icon path={mdiLockReset} size={0.75} />
                                            </Tooltip>
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={handleSettingsOpen}
                                        >
                                            <Icon path={mdiCog} size={0.75} />
                                        </IconButton>

                                    </Box>
                                </Box>
                            ) : null
                        }
                    </Box>
                </Box>
            </Paper>
        </Modal>
    );
}

export default TripDataViewModal;